import { makeThemeColor, SECONDARY, TERTIARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export const COLOR = makeThemeColor(SECONDARY);
export const ICON_COLOR = makeThemeColor(TERTIARY);

export const BORDER_RADIUS = 4;

export const getInitialStyle = ({ colorMode } = defaultContext) => ({
  color: COLOR[colorMode],
  iconColor: ICON_COLOR[colorMode],
  shader: {
    radius: BORDER_RADIUS,
  },
});
